import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { ProfileType } from '../enums/visa-types.enum';

export const checkAccountGuard: CanActivateFn & CanActivateChildFn = (route, state) => {

  const commonService = inject(CommonService);
  const profileType = commonService.getProfileTypeFromPortal();
  const router = inject(Router);
  if (profileType == "") {
    if (state.url.includes('government') || state.url.includes('business')) {
      router.navigate([commonService.getRouteStartIndex() + '/']);
      return false;
    }
    else {
      return true;
    }
  }
  else if (profileType == ProfileType.Government) {
    if(state.url.includes('government') ) {
      return true;
    }
    else {
      router.navigate([commonService.getRouteStartIndex() + '/']);
      return false;
    }
  }
  else if (profileType == ProfileType.Commercial) {
    if(state.url.includes('business') ) {
      return true;
    }
    else {
      router.navigate([commonService.getRouteStartIndex() + '/']);
      return false;
    }
  }
  else {
    return false;
  } 
};
